import { ClientCurrencyReplenishmentList } from "@/components/client/currencyReplenishment/ClientCurrencyReplenishmentList"
import { useStore } from "../../../stores/RootStoreContext"
import { CurrencyManagerReplenishmentList } from "@/components/manager/currencyReplenishment/CurrencyManagerReplenishmentList"

export const CurrencyReplenishmentList = () => {
  const { userStore } = useStore()

  if (userStore.isClient) {
    return <ClientCurrencyReplenishmentList />
  } else if (userStore.isManager || userStore.isAdmin) {
    return <CurrencyManagerReplenishmentList />
  } else {
    return <></>
  }
}
